export default __webpack_public_path__ + "static/bt_mockup-058014fcf68448cb18e6b160492b8d51.png";